import { Image, StyleSheet, Text as RNText, View } from 'react-native';

import { Card } from '@/components/Card';
import { Text } from '@/components/Text';
import { colors, fonts, fontSizes, radii, spacing } from '@/constants/theme';
import type { GiftProduct } from '@/types/gifting';

/** The compact what-you're-claiming summary shown above the shipping form. */
export function ClaimProductCard({ product }: { product: GiftProduct }) {
  return (
    <Card style={styles.productCard}>
      <View style={styles.productRow}>
        <View style={styles.productImageWrap}>
          {product.image_url ? (
            <Image
              source={{ uri: product.image_url }}
              style={styles.productImage}
              resizeMode="cover"
            />
          ) : (
            <View style={styles.productImageFallback}>
              <RNText style={styles.productImageFallbackText}>{product.name.slice(0, 1)}</RNText>
            </View>
          )}
        </View>
        <View style={styles.productMeta}>
          <Text variant="bodySemiBold">{product.name}</Text>
          <Text variant="caption" color="textMuted">
            {product.receive_text}
          </Text>
        </View>
      </View>
    </Card>
  );
}

const styles = StyleSheet.create({
  productCard: {
    marginTop: spacing.lg,
  },
  productRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.base,
  },
  productImageWrap: {
    width: 72,
    height: 72,
    borderRadius: radii.base,
    overflow: 'hidden',
    backgroundColor: colors.background,
  },
  productImage: {
    width: '100%',
    height: '100%',
  },
  productImageFallback: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.brightGreenSoft,
  },
  productImageFallbackText: {
    fontFamily: fonts.display,
    fontSize: fontSizes['2xl'],
    color: colors.deepGreen,
  },
  productMeta: {
    flex: 1,
    gap: 2,
  },
});
